import { CheckboxGroup } from 'common/components/cookbook/CheckboxGroup';
import { PopoverContent } from 'common/components/cookbook/PopoverContent';
import { Stack } from 'common/components/cookbook/Stack';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

import { OverrideReason } from '../api-types';
import { overrideManagementRouteApi } from '../routeApi';

const overrideReasonCodes: OverrideReason[] = [
  'ANNUAL_EVENT',
  'BASELINE_CORRECTION',
  'FREE_DELIVERY_CAMPAIGN',
  'HOLIDAY',
  'LOST_SALES_CORRECTION',
  'MARKDOWN',
  'MARKETING_CAMPAIGN',
  'OTHER',
  'PROMOTION',
  'SEASONAL_SELECTION',
  'STORE_CLOSE',
] as const;

export const ReasonCodesFilterPopoverContent = () => {
  const format = useFormatMessage();

  const { overrideReasons = [] } = overrideManagementRouteApi.useSearch();
  const navigate = overrideManagementRouteApi.useNavigate();

  return (
    <PopoverContent>
      <Stack gap="regularMedium">
        <CheckboxGroup
          name="overrideReasons"
          value={overrideReasons}
          onChange={(value) => {
            void navigate({
              search: (prev) => ({
                ...prev,
                overrideReasons: value.length > 0 ? value : undefined,
                page: undefined,
              }),
            });
          }}
          options={overrideReasonCodes.map((option) => ({
            label: format(`forecasting.reason_code:${option}`),
            value: option,
          }))}
        />
      </Stack>
    </PopoverContent>
  );
};
